import { combineReducers } from '@reduxjs/toolkit';
import app from './slices/app';
import env from './slices/env';
import config from './slices/config';
import navigation from './slices/navigation';
import articles from './slices/articles';

const rootReducer = combineReducers({
  app,
  env,
  config,
  navigation,
  articles,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
